import React from 'react';
import { Map, Calendar, Video, Cloud, Clapperboard } from 'lucide-react';

interface FilterSectionProps {
  title: string;
  items: string[];
  selected: string[];
  onToggle: (item: string) => void;
}

export default function FilterSection({
  title,
  items,
  selected,
  onToggle,
}: FilterSectionProps) {
  let icon;
  switch (title) {
    case 'Trajectory':
      icon = <Map className="inline-block w-5 h-5 mr-2 text-blue-500" />;
      break;
    case 'Deployment':
      icon = (
        <Clapperboard className="inline-block w-5 h-5 mr-2 text-red-500" />
      );
      break;
    case 'Season':
      icon = <Calendar className="inline-block w-5 h-5 mr-2 text-orange-500" />;
      break;
    case 'Sensors':
      icon = <Video className="inline-block w-5 h-5 mr-2 text-purple-500" />;
      break;
    case 'Conditions':
      icon = <Cloud className="inline-block w-5 h-5 mr-2 text-gray-500" />;
      break;
    default:
      icon = null;
  }

  return (
    <div className="space-y-2 text-center">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white border-b border-gray-300 dark:border-gray-600 pb-1 inline-flex items-center justify-center gap-2">
        {icon} {title}
      </h3>
      <div className="flex flex-wrap justify-center items-center gap-2">
        {items && Array.isArray(items) ? (
          items.map((item, idx) => {
            const isReset = item === 'All';
            const isSelected = selected.includes(item);
            const showSeparator = isReset && idx < items.length - 1;
            return (
              <React.Fragment key={item}>
                <button
                  onClick={() => onToggle(item)}
                  className={`px-4 py-2 rounded transition-transform duration-200 ease-in-out font-medium
                    ${
                      isSelected
                        ? isReset
                          ? 'bg-blue-500 text-white'
                          : 'bg-green-500 text-white'
                        : 'bg-gray-200 dark:bg-gray-700 text-black dark:text-white'
                    }
                    hover:scale-105 active:scale-95
                  `}
                >
                  {item}
                </button>
                {showSeparator && (
                  <span className="text-gray-300 dark:text-gray-600 select-none">
                    |
                  </span>
                )}
              </React.Fragment>
            );
          })
        ) : (
          <p>No items available</p>
        )}
      </div>
    </div>
  );
}
